import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": "950"
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isSaving
    },
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5 mb-4"
  }, [_vm._v(" " + _vm._s(!!_vm.form.template.id ? "Template " + _vm.form.template.name : "New template") + " ")])]), _c(VCardText, [_c("MailTemplateForm", {
    key: "from_modal_".concat(_vm.form.template.id),
    ref: "form",
    attrs: {
      "no-uploader": "",
      "no-files": "",
      placeholders: _vm.placeholders
    },
    on: {
      "click:placeholder": _vm.clickPlaceholder
    },
    scopedSlots: _vm._u([{
      key: "submit",
      fn: function fn(innerForm) {
        return [_c(VCardActions, {
          staticClass: "trick-margins"
        }, [_c(VSpacer), _c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: "",
            disabled: _vm.isSaving
          },
          on: {
            click: _vm.close
          }
        }, [_vm._v(" Cancel ")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: "",
            loading: _vm.isSaving
          },
          on: {
            click: function click($event) {
              return _vm.save(innerForm);
            }
          }
        }, [_vm._v(" Save ")])], 1)];
      }
    }]),
    model: {
      value: _vm.form.template,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "template", $$v);
      },
      expression: "form.template"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };